import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Auth API
export const loginUser = async (username, password, user_type) => {
  try {
    const response = await axios.post(`${API}/login`, {
      username,
      password,
      user_type
    });
    return response.data;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

// Products API
export const getProducts = async () => {
  try {
    const response = await axios.get(`${API}/products`);
    return response.data;
  } catch (error) {
    console.error('Get products error:', error);
    return [];
  }
};

export const createProduct = async (product) => {
  try {
    const response = await axios.post(`${API}/products`, product);
    return response.data;
  } catch (error) {
    console.error('Create product error:', error);
    throw error;
  }
};

export const updateProduct = async (productId, product) => {
  try {
    const response = await axios.put(`${API}/products/${productId}`, product);
    return response.data;
  } catch (error) {
    console.error('Update product error:', error);
    throw error;
  }
};

export const deleteProduct = async (productId) => {
  try {
    const response = await axios.delete(`${API}/products/${productId}`);
    return response.data;
  } catch (error) {
    console.error('Delete product error:', error);
    throw error;
  }
};

// Customers API
export const getCustomers = async () => {
  try {
    const response = await axios.get(`${API}/customers`);
    return response.data;
  } catch (error) {
    console.error('Get customers error:', error);
    return [];
  }
};

export const createCustomer = async (customer) => {
  try {
    const response = await axios.post(`${API}/customers`, customer);
    return response.data;
  } catch (error) {
    console.error('Create customer error:', error);
    throw error;
  }
};

export const updatePassword = async (userId, newPassword, userType) => {
  try {
    const response = await axios.post(`${API}/update-password`, {
      userId,
      newPassword,
      userType
    });
    return response.data;
  } catch (error) {
    console.error('Update password error:', error);
    throw error;
  }
};

export const updateUsername = async (userId, newUsername) => {
  try {
    const response = await axios.post(`${API}/update-username`, {
      userId,
      newUsername
    });
    return response.data;
  } catch (error) {
    console.error('Update username error:', error);
    throw error;
  }
};

// Transactions API
export const getTransactions = async () => {
  try {
    const response = await axios.get(`${API}/transactions`);
    return response.data;
  } catch (error) {
    console.error('Get transactions error:', error);
    return [];
  }
};

export const getCustomerTransactions = async (customerId) => {
  try {
    const response = await axios.get(`${API}/transactions/${customerId}`);
    return response.data;
  } catch (error) {
    console.error('Get customer transactions error:', error);
    return [];
  }
};

export const createTransaction = async (transaction) => {
  try {
    const response = await axios.post(`${API}/transactions`, transaction);
    return response.data;
  } catch (error) {
    console.error('Create transaction error:', error);
    throw error;
  }
};

// Bank Accounts API
export const getBankAccounts = async (adminId) => {
  try {
    const response = await axios.get(`${API}/bank-accounts?admin_id=${adminId}`);
    return response.data;
  } catch (error) {
    console.error('Get bank accounts error:', error);
    return [];
  }
};

export const createBankAccount = async (account) => {
  try {
    const response = await axios.post(`${API}/bank-accounts`, account);
    return response.data;
  } catch (error) {
    console.error('Create bank account error:', error);
    throw error;
  }
};

export const deleteBankAccount = async (accountId) => {
  try {
    const response = await axios.delete(`${API}/bank-accounts/${accountId}`);
    return response.data;
  } catch (error) {
    console.error('Delete bank account error:', error);
    throw error;
  }
};

// Stripe Payment API
export const createStripeCheckout = async (checkoutData) => {
  try {
    const response = await axios.post(`${API}/stripe/checkout`, checkoutData);
    return response.data;
  } catch (error) {
    console.error('Stripe checkout error:', error);
    throw error;
  }
};

export const checkPaymentStatus = async (sessionId) => {
  try {
    const response = await axios.get(`${API}/stripe/status/${sessionId}`);
    return response.data;
  } catch (error) {
    console.error('Payment status error:', error);
    throw error;
  }
};

// Admin Settings API
export const getAdminSettings = async (adminId) => {
  try {
    const response = await axios.get(`${API}/admin-settings/${adminId}`);
    return response.data;
  } catch (error) {
    console.error('Get admin settings error:', error);
    return { notificationEmail: null, emailNotificationsEnabled: false };
  }
};

export const updateAdminSettings = async (adminId, settings) => {
  try {
    const response = await axios.post(`${API}/admin-settings/${adminId}`, settings);
    return response.data;
  } catch (error) {
    console.error('Update admin settings error:', error);
    throw error;
  }
};
